import React, { useCallback, useState } from "react";
import { FiPrinter } from "react-icons/fi";
import { FaArrowDown } from "react-icons/fa";
import { Tooltip } from "antd";
import { useIntl } from "react-intl";
import {
  Actions,
  ButtonFormConfirm,
  Container,
  CredentialsListContainer,
  CredentialsListLabel,
  FooterContainer,
  HeaderModal,
  IconButton,
  Message,
  ModalSubTitle,
  ModalTitle,
  ModalWithdrawalAndDisassociate,
  StyledInput,
} from "./styles";
import back from "../../components/Icons/back.svg";
import { Form, notification, Select } from "antd";
import ReactInputMask from "react-input-mask";
import { validation } from "../../../../newUXPages/Credentials/Register/NewEmployee/validations";
import api from "../../../../service";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { DotIcon } from "../../ServicePanel/card-icons";
import {
  StyledDDISelect,
  StyledFormItem,
  TelephoneSpan,
  FlagOption,
  PhoneErrorText,
} from "../../../../components/ModalNewCollaborator/styles";
import { Flex } from "../../Services/Sales/PurchaseSummary/style";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import pt from "react-phone-number-input/locale/pt.json";
import flags from "react-phone-number-input/flags";
import { verifyDefaulter } from "../../../../redux/modules/defaulters/actions";
import generateHeaders from "../../../../utils/generateHeaders";
import printJS from "print-js";
import ConfirmationModalContent from "../ConfirmationModalContent";
import PrintCredential from "../PrintCredential";
import { DEFAULT_DDI_COUNTRY_VALUE } from "../../../../utils/declarationConstants";

const { Option } = Select;

const CredentialsPrintedTab = ({
  selectedRowKeys,
  fetchData,
  setSelectedRows,
  companyNameCredential,
  onWithdrawnNow,
}) => {
  const intl = useIntl();
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const { isDefaulter, isLoading } = useSelector((state) => state.defaulters);
  const contractNumber = localStorage.getItem("serviceContractNumber");
  const dispatch = useDispatch();

  useEffect(() => {
    if (contractNumber) {
      dispatch(verifyDefaulter({ contractNumber }));
    }
  }, [contractNumber, dispatch]);

  return (
    <>
      {!isLoading && (
        <PrintCredential
          defaulter={isDefaulter}
          fetchData={fetchData}
          open={showPrintModal}
          setOpen={setShowPrintModal}
          selectedRowKeys={selectedRowKeys}
          setSelectedRows={setSelectedRows}
          companyNameCredential={companyNameCredential}
          isFirstPrint={false}
        />
      )}

      {!isLoading && (
        <Withdrawal
          fetchData={fetchData}
          open={showWithdrawModal}
          setOpen={setShowWithdrawModal}
          selectedRowKeys={selectedRowKeys}
          setSelectedRows={setSelectedRows}
          onWithdrawnNow={onWithdrawnNow}
        />
      )}

      <Container>
        <Message>
          {selectedRowKeys.length > 0 ? (
            <>
              <span>
                {intl.formatMessage({
                  id: "selected_credentials",
                })}
              </span>
              <span style={{ fontWeight: "bold", marginLeft: "5px" }}>
                {String(selectedRowKeys.length).padStart(2, "0")}
              </span>
            </>
          ) : (
            intl.formatMessage({
              id: "select_at_least_one_credential_to_reprint_or_withdraw",
            })
          )}
        </Message>
        <Actions>
          <Tooltip
            title={intl.formatMessage({ id: "reprint_credential" })}
            placement="top"
          >
            <span style={{ display: "inline-flex" }}>
              <IconButton
                onClick={() => setShowPrintModal(true)}
                disabled={selectedRowKeys.length === 0}
                active={selectedRowKeys.length > 0}
              >
                <FiPrinter />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip
            title={intl.formatMessage({ id: "withdraw_credential" })}
            placement="top"
          >
            <span style={{ display: "inline-flex" }}>
              <IconButton
                onClick={() => setShowWithdrawModal(true)}
                disabled={selectedRowKeys.length === 0}
                active={selectedRowKeys.length > 0}
              >
                <FaArrowDown />
              </IconButton>
            </span>
          </Tooltip>
        </Actions>
      </Container>
    </>
  );
};

export default CredentialsPrintedTab;

export function Withdrawal({
  open,
  setOpen,
  selectedRowKeys,
  setSelectedRows,
  fetchData,
  onWithdrawnNow,
}) {
  const [currentStep, setCurrentStep] = useState(1);
  const intl = useIntl();
  const [withdrawForm] = Form.useForm();
  const [countryList, setCountryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    const reactCountries = getCountries().map((country) => {
      const code = `+${getCountryCallingCode(country)}`;
      const countryName = intl.locale === "en" ? en[country] : pt[country];
      return {
        label: `${code} - ${countryName}`,
        value: code,
        name: countryName,
        key: `${code}-${country}`,
        countryCode: country,
      };
    });
    setCountryList(reactCountries.sort((a, b) => a.name.localeCompare(b.name)));
  }, [intl.locale]);

  useEffect(() => {
    if (open) {
      withdrawForm.setFieldValue("ddi", DEFAULT_DDI_COUNTRY_VALUE);
    }
  }, [open, withdrawForm]);

  const reset = useCallback(() => {
    setLoading(false);
    fetchData();
    setCurrentStep(1);
    setSelectedRows([]);
    withdrawForm.resetFields();
  }, [fetchData, setSelectedRows, withdrawForm]);

  const onFinishWithdraw = useCallback(async () => {
    try {
      const options = generateHeaders(token);
      setLoading(true);

      const credentialIds = selectedRowKeys.map((item) => item.id);
      const values = await withdrawForm.validateFields();

      const sanitizedValues = JSON.stringify({
        phone: `+${values.ddi.replace(/\D/g, "")}${values.telephone.replace(
          /\D/g,
          ""
        )}`,
        email: values.email,
        name: values.withdrawnBy,
        credentialIds,
        eventId: localStorage.getItem("serviceEventId"),
        opportunityId: localStorage.getItem("serviceOpportunityId"),
        userId: localStorage.getItem("serviceSystemUserId"),
        printCredential: false,
        withdrawCredential: true,
      });

      const response = await api.post(
        "/credential-reports/staff-withdraw",
        sanitizedValues,
        options
      );

      setOpen(false);

      const protocolReport = response.data?.protocolReport || null;

      if (protocolReport?.id) {
        printJS({
          printable: protocolReport.file,
          type: "pdf",
          base64: true,
        });
      }

      if (onWithdrawnNow) {
        onWithdrawnNow(credentialIds);
      }

      reset();
    } catch (error) {
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + (error.response?.data?.code || "unknown"),
        }),
      });
      setLoading(false);
    }
  }, [withdrawForm, reset, selectedRowKeys, setOpen, token, onWithdrawnNow]);

  const handleCloseModal = () => {
    reset();
    setOpen(false);
  };

  return (
    <ModalWithdrawalAndDisassociate
      width={658}
      height={"auto"}
      closable={false}
      onCancel={handleCloseModal}
      visible={open}
      footer={""}
      destroyOnClose
      centered={true}
    >
      <div>
        <HeaderModal>
          <div className="icon">
            <FaArrowDown
              style={{ fontSize: "18px", color: "rgba(6, 142, 195, 1)" }}
            />
          </div>
          <ModalTitle>
            {intl.formatMessage({ id: "withdraw_credential" })}
          </ModalTitle>
        </HeaderModal>
        {currentStep === 1 ? (
          <>
            <ModalSubTitle>
              {intl.formatMessage({
                id: "confirm_withdrawal_of_credentials",
              })}
            </ModalSubTitle>
            <br />
            <ModalSubTitle style={{ fontWeight: "bold" }}>
              {intl.formatMessage({ id: "this_action_cannot_be_undone" })}
            </ModalSubTitle>
            <CredentialsListContainer>
              {selectedRowKeys.map((row) => (
                <CredentialsListLabel key={row.id}>
                  <DotIcon color="#D9D9D9" size={7} />
                  {row.collaboratorName}
                </CredentialsListLabel>
              ))}
            </CredentialsListContainer>
          </>
        ) : (
          <Form
            form={withdrawForm}
            onFinish={onFinishWithdraw}
            layout="vertical"
          >
            <StyledFormItem
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({ id: "error.field_required" }),
                },
              ]}
              label={intl.formatMessage({ id: "withdrawn_by" })}
              name="withdrawnBy"
            >
              <StyledInput
                placeholder={intl.formatMessage({ id: "withdrawn_by" })}
              />
            </StyledFormItem>

            <StyledFormItem
              label={intl.formatMessage({ id: "email" })}
              name="email"
              rules={validation("email", intl)}
            >
              <StyledInput placeholder={intl.formatMessage({ id: "email" })} />
            </StyledFormItem>

            <Flex gap="8px" items="end" justify="flex-start">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "8px",
                }}
              >
                <TelephoneSpan>
                  {intl.formatMessage({ id: "telephone" })}
                  <span className="required">*</span>
                </TelephoneSpan>
                <StyledFormItem
                  name="ddi"
                  noStyle
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "error.field_required",
                      }),
                    },
                  ]}
                >
                  <StyledDDISelect
                    showSearch
                    optionLabelProp="label"
                    dropdownMatchSelectWidth={280}
                    placeholder={"DDI"}
                    filterOption={(input, option) => {
                      const searchTerm = input
                        .toLowerCase()
                        .replace(/[+\s-]/g, "");

                      const optionValue = (option?.filterLabel || "")
                        .toLowerCase()
                        .replace(/[+\s-]/g, "");

                      return optionValue.includes(searchTerm);
                    }}
                  >
                    {countryList.map((country) => {
                      const Flag = flags[country.countryCode];
                      return (
                        <Option
                          key={country.key}
                          value={country.value}
                          filterLabel={country.label}
                          label={
                            <FlagOption>
                              {Flag && <Flag title={country.name} />}
                              {country.value}
                            </FlagOption>
                          }
                        >
                          <FlagOption>
                            {Flag && <Flag title={country.name} />}
                            {country.label}
                          </FlagOption>
                        </Option>
                      );
                    })}
                  </StyledDDISelect>
                </StyledFormItem>
              </div>
              <StyledFormItem
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "error.field_required",
                    }),
                  },
                ]}
                name="telephone"
                noStyle
              >
                <StyledInput
                  style={{ flex: 1 }}
                  placeholder={`(DDD) + ${intl.formatMessage({
                    id: "telephone",
                  })}`}
                  as={ReactInputMask}
                  mask="(99) 99999-9999"
                  maskPlaceholder={null}
                  alwaysShowMask={false}
                />
              </StyledFormItem>
            </Flex>
            <Form.Item shouldUpdate noStyle>
              {() => {
                const message =
                  withdrawForm.getFieldError("ddi")[0] ||
                  withdrawForm.getFieldError("telephone")[0];
                return message ? (
                  <PhoneErrorText>{message}</PhoneErrorText>
                ) : null;
              }}
            </Form.Item>
          </Form>
        )}
        <FooterContainer>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {currentStep > 1 && (
              <img
                onClick={() => setCurrentStep(currentStep - 1)}
                src={back}
                alt="back"
                style={{ cursor: "pointer" }}
              />
            )}
            <span className="steps">{`${currentStep} ${intl.formatMessage({
              id: "of",
            })} 2`}</span>
          </div>

          <div style={{ marginRight: "10px" }}>
            <ButtonFormConfirm
              onClick={() => {
                reset();
                setOpen(false);
              }}
              style={{ border: "none" }}
            >
              {intl.formatMessage({ id: "cancel" })}
            </ButtonFormConfirm>
            <ButtonFormConfirm
              loading={loading}
              onClick={() =>
                currentStep === 2
                  ? withdrawForm.submit()
                  : setCurrentStep(currentStep + 1)
              }
              style={{
                backgroundColor: "rgba(6, 142, 195, 1)",
                color: "rgba(255, 255, 255, 1)",
              }}
            >
              {intl.formatMessage({ id: "confirm" })}
            </ButtonFormConfirm>
          </div>
        </FooterContainer>
      </div>
    </ModalWithdrawalAndDisassociate>
  );
}
